import { useTitle as useTitleAhooks } from 'ahooks';

import { CHARS } from '@ll-platform/shared-utils/string';
import { truthy } from '@ll-platform/shared-utils/types';

type BuildTitleOptions = {
  title?: string;
  project?: string;
  msa?: string;
  brand?: string;
  suffix?: string;
};

export function useTitle({
  title,
  project,
  msa,
  brand,
  suffix,
}: BuildTitleOptions) {
  const msaWithBrand = [msa, brand].filter(truthy).join(' ');
  const pageTitle = [title, project, msaWithBrand, suffix]
    .filter(truthy)
    .join(` ${CHARS.middleDash} `);

  useTitleAhooks(pageTitle || 'Lemonlight');
}
